import {StockMovementEditor} from "./CreateOpeningStock.jsx";
export default function CreateDelivery(props){return <StockMovementEditor {...props} kind="delivery"/>;}
